import { PatrimoineSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const PatrimoineModel: SelectorModel = {
  name: 'patrimoines',
  getSelector: PatrimoineSelectors.selectAllPatrimoinesDictionary,
  isReady: PatrimoineSelectors.selectIsReadyPatrimoine
};
